// FILE: client/src/screens/ShopEntry.js
import React, { useEffect, useState } from "react";
import ShopScreen from "../shop/ShopScreen";
import MobileShopScreen from "../shop/MobileShopScreen";

/**
 * ShopEntry
 * Renders desktop ShopScreen OR MobileShopScreen
 * based on viewport width.
 *
 * Usage:
 *   <ShopEntry />
 */
export default function ShopEntry({ breakpoint = 991.98 }) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e) => setIsMobile(e.matches);

    setIsMobile(mq.matches);

    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, [breakpoint]);

  if (isMobile) return <MobileShopScreen />;

  return <ShopScreen />;
}